import '@atlassian/jira-vendor/src/vendor-parcel.tsx';
import '@atlassian/jira-vendor/src/commons-parcel.tsx';

import React from 'react';
import { render } from 'react-dom';
import { JiraContextContainer } from '@atlassian/jira-context-container/src/JiraContextContainer.tsx';
import { StrictMode } from '@atlassian/jira-react-strict-mode/src/StrictMode.tsx';
import { UpFlowApp } from '@atlassian/jira-up-flow-touchpoint/src/ui/up-flow-app/index.tsx';

const renderUpflow = (domId: any, touchpointId: any) => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const placeholder = document.getElementById(domId);
	if (!placeholder) {
		throw new Error('placeholder was not found whilst trying to create the upflow-app.');
	}

	render(
		<StrictMode>
			<JiraContextContainer>
				<UpFlowApp touchpointId={touchpointId} />
			</JiraContextContainer>
		</StrictMode>,
		placeholder,
	);
};

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window.JIRA_UPFLOW = {
	// @ts-expect-error - TS7006 - Parameter 'domId' implicitly has an 'any' type. | TS7006 - Parameter 'touchpointId' implicitly has an 'any' type.
	render: (domId, touchpointId) => renderUpflow(domId, touchpointId),
};
